// État d'une demande de consentement Enedis (règle du 16/10/2026) : une seule colonne qui suit la démarche du client
// puis la récupération de la courbe de charge. L'état de la courbe vient du serveur (etatCourbe : VALIDE, RECUE,
// NON_RECUE ; WizardEnedisService.completerEtatsCourbe).

export const ETATS = ['NOUVELLE', 'MAIL_CLIQUE', 'DEMARCHE_COMMENCEE', 'VALIDE', 'COURBE_RECUE', 'COURBE_NON_RECUE', 'EXPIRE']

/** Au-delà de 20 % de semaines extrapolées, la courbe reçue est affichée en vert hachuré (seuil de la Step 3). */
export const PART_REELLE_MIN = 80

/** Fin de validité d'un accord reçu : date d'autorisation + durée en mois ; null si l'accord n'est pas encore donné. */
export function finDeValidite(consent: any): Date | null {
  if (!consent || consent.status !== 'AUTHORIZED' || !consent.authorizationDatetime) return null
  const d = new Date(consent.authorizationDatetime)
  d.setMonth(d.getMonth() + (consent.durationMonth || 0))
  return d
}

export function etatDuConsentement(consent: any, maintenant: Date = new Date()): string {
  if (!consent || !consent.status) return 'NOUVELLE'
  if (consent.status === 'NEW') return 'NOUVELLE'
  if (consent.status === 'PRESENTATION_VIEWED') return 'MAIL_CLIQUE'
  if (consent.status === 'STARTED') return 'DEMARCHE_COMMENCEE'
  const fin = finDeValidite(consent)
  if (fin && consent.durationMonth > 0 && fin < maintenant) return 'EXPIRE'
  if (consent.etatCourbe === 'RECUE') return 'COURBE_RECUE'
  if (consent.etatCourbe === 'NON_RECUE') return 'COURBE_NON_RECUE'
  return 'VALIDE'
}

function jour(d: any): string {
  if (!d) return ''
  const [a, m, j] = String(d).substring(0, 10).split('-')
  return j + '/' + m + '/' + a
}

export interface EtatAffiche { text: string; textLong: string; color: string; hachure?: boolean }

export function etatConsentement(etat: string, consent: any = {}): EtatAffiche {
  switch (etat) {
    case 'MAIL_CLIQUE':
      return { text: 'Mail cliqué', textLong: 'Le client a cliqué sur le lien reçu par mail', color: '#009fe3' }
    case 'DEMARCHE_COMMENCEE':
      return { text: 'Démarche commencée', textLong: 'Le client a commencé la démarche sur son espace client Enedis', color: '#e0a800' }
    case 'VALIDE':
      return {
        text: 'Consentement validé',
        textLong: 'Le client a validé la demande de consentement. RETIX récupère automatiquement la courbe de charge.',
        color: '#7b3fbf',
      }
    case 'COURBE_RECUE': {
      const part = consent.partReelle
      const periode = consent.courbeDu && consent.courbeAu ? ' (du ' + jour(consent.courbeDu) + ' au ' + jour(consent.courbeAu) + ')' : ''
      return {
        text: 'Courbe reçue',
        textLong: part != null ? 'Données réelles : ' + part + ' %' + periode : 'Courbe de charge reçue',
        color: '#28a745',
        hachure: part != null && part < PART_REELLE_MIN,
      }
    }
    case 'COURBE_NON_RECUE':
      return { text: 'Courbe non reçue', textLong: 'RETIX n\'a pas réussi à récupérer automatiquement la courbe de charge', color: '#c62828' }
    case 'EXPIRE':
      return { text: 'Consentement expiré', textLong: 'Le consentement a expiré', color: '#8a8f98' }
    default:
      return { text: 'Nouvelle demande', textLong: 'Le client n\'a pas encore cliqué sur le lien reçu par mail', color: '#1a1a2e' }
  }
}
